<div class="list">
  <div class="box-finality">
    <div>
      <span *ngIf="!isMobile" id="title">
        Finalidade do envio: {{ finality?.description }}
      </span>
      <p *ngIf="isMobile" id="title">
        Finalidade do envio: {{ finality?.description }}
      </p>
      <br *ngIf="isMobile" />
      <p class="p-text-grey">
        {{ finality?.fullDescription }}
      </p>
    </div>
    <br *ngIf="isMobile" />
    <div *ngIf="!warrenGlobalOnly" (click)="back()">
      <p class="btn-blue change-finality">Alterar finalidade</p>
    </div>
  </div>

  <p class="name padding-top-24 padding-bottom-24">
    {{ !warrenGlobalOnly ? "Beneficiários salvos" : "Beneficiário salvo" }}
  </p>
  <ng-container *ngIf="!warrenGlobalOnly">
    <div class="saved-beneficiaries">
      <div class="scroll-beneficiary">
        <div *ngFor="let contact of userContacts" class="beneficiary-card">
          <mat-radio-button
            name="beneficiary"
            class="custom-radio"
            (click)="onContactSelect(contact)"
            [checked]="
              !isNewBeneficiary &&
              (contact.senderReceiverName == form.value.senderReceiverName ||
                contact.senderReceiverName == data?.receiver?.name)
            "
          ></mat-radio-button>

          <div class="d-flex align-items-center">
            <div class="texts">
              <img
                src="assets/icons/user-icon.svg"
                alt="user"
                class="icon-user"
              />
              <span class="fw-semibold">{{ contact?.senderReceiverName }}</span>
              <span *ngIf="!isMobile">{{
                getCurrencyDescription(contact?.currency)
              }}</span>
              <span *ngIf="!isMobile">{{ contact?.country?.description }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="beneficiary-card new" (click)="onNewBeneficiary()">
        <mat-radio-button
          name="beneficiary"
          class="custom-radio"
          [checked]="isNewBeneficiary"
        ></mat-radio-button>

        <div class="d-flex align-items-center">
          <div class="texts">
            <img src="assets/icons/user-add.svg" alt="user" class="icon-user" />
            <span class="fw-semibold">Novo beneficiário</span>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="isFormVisible">
    <form [formGroup]="form" class="row mt-4">
      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Nome do beneficiário</mat-label>
          <input
            matInput
            type="text"
            formControlName="senderReceiverName"
            required
          />
          <mat-error
            *ngIf="
              form.get('senderReceiverName')?.touched &&
              form.get('senderReceiverName')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>E-mail</mat-label>
          <input matInput type="email" formControlName="email" required />
          <mat-error *ngIf="form.get('email')?.touched">
            <ng-container *ngIf="form.get('email')?.hasError('required')">
              Campo obrigatório
            </ng-container>
            <ng-container *ngIf="form.get('email')?.hasError('email')">
              E-mail inválido
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>País do beneficiário</mat-label>
          <mat-select formControlName="country" [compareWith]="compareCountry">
            <mat-option
              *ngFor="let country of countries$ | async"
              [value]="country"
            >
              {{ country.description }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              form.get('country')?.touched &&
              form.get('country')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Moeda</mat-label>
          <mat-select formControlName="currency">
            <mat-option *ngFor="let moeda of moedas" [value]="moeda">
              <img [src]="moeda.image" width="20px" height="20px" />
              <span class="ml-2">{{ moeda.description }}</span>
            </mat-option>
            <mat-select-trigger>
              <img
                [src]="form.get('currency')?.value?.image"
                width="20px"
                height="20px"
                class="currency-img"
              />
              <span class="ml-2">{{
                form.get("currency")?.value?.description
              }}</span>
            </mat-select-trigger>
          </mat-select>

          <mat-error
            *ngIf="
              form.get('currency')?.touched &&
              form.get('currency')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Banco</mat-label>
          <input matInput formControlName="name" required />
          <mat-error
            *ngIf="
              form.get('name')?.touched &&
              form.get('name')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Valor enviado</mat-label>
          <input
            matInput
            formControlName="amount"
            currencyMask
            [options]="{
              prefix: currency?.value + ' ',
              thousands: '.',
              decimal: ','
            }"
          />
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'number')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Número da conta</mat-label>
          <input matInput formControlName="number" required />
          <mat-error
            *ngIf="
              form.get('number')?.touched &&
              form.get('number')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>SWIFT</mat-label>
          <input matInput formControlName="swift" required />
          <mat-error
            *ngIf="
              form.get('swift')?.touched &&
              form.get('swift')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="finality?.id === 22 || finality?.id === 30">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>FFC</mat-label>
          <input matInput formControlName="fcc" required />
          <mat-error
            *ngIf="
              form.get('fcc')?.touched && form.get('fcc')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'iban')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>IBAN</mat-label>
          <input matInput formControlName="iban" required />
          <mat-error
            *ngIf="
              form.get('iban')?.touched &&
              form.get('iban')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'aba')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>ABA</mat-label>
          <input matInput formControlName="aba" />
          <mat-error
            *ngIf="
              form.get('aba')?.touched && form.get('aba')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'blz')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>BLZ</mat-label>
          <input matInput formControlName="blz" />
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'cbu')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CBU</mat-label>
          <input matInput formControlName="cbu" required />
          <mat-error
            *ngIf="
              form.get('cbu')?.touched && form.get('cbu')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'cuit')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>CUIT</mat-label>
          <input matInput formControlName="cuit" />
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'bsb')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>BSB</mat-label>
          <input matInput formControlName="bsb" />
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'institutionNumber')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Institution Number</mat-label>
          <input matInput formControlName="institutionNumber" required />
          <mat-error
            *ngIf="
              form.get('institutionNumber')?.touched &&
              form.get('institutionNumber')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'transit')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Transit</mat-label>
          <input matInput formControlName="transit" required />
          <mat-error
            *ngIf="
              form.get('transit')?.touched &&
              form.get('transit')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-6" *ngIf="shouldShowField(form, 'address')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Endereço</mat-label>
          <input matInput formControlName="address" required />
          <mat-error
            *ngIf="
              form.get('address')?.touched &&
              form.get('address')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'cable')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Cable</mat-label>
          <input matInput formControlName="cable" required />
          <mat-error
            *ngIf="
              form.get('cable')?.touched &&
              form.get('cable')?.hasError('required')
            "
          >
            Campo obrigatório
          </mat-error>
        </mat-form-field>
      </div>

      <div class="col-md-4" *ngIf="shouldShowField(form, 'sortCode')">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Sort Code</mat-label>
          <input matInput formControlName="sortCode" />
        </mat-form-field>
      </div>

      <div class="col-md-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Observação</mat-label>
          <input matInput type="text" formControlName="observation" maxlength="100" />
          <mat-hint align="end">{{ form.get('observation')?.value?.length || 0 }}/100</mat-hint>
        </mat-form-field>
      </div>

      <div *ngIf="!warrenGlobalOnly" class="col-md-12 mt-2 mb-4">
        <mat-slide-toggle
          [checked]="showIntermediary"
          (change)="showIntermediary = !showIntermediary"
          >Incluir banco intermediário (opcional)
        </mat-slide-toggle>
      </div>
    </form>
  </ng-container>
  <div *ngIf="showIntermediary" [formGroup]="intermediaryBankForm" class="row">
    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>País *</mat-label>
        <mat-select formControlName="country" [compareWith]="compareCountry">
          <mat-option
            *ngFor="let country of countries$ | async"
            [value]="country"
            >{{ country.description }}</mat-option
          >
        </mat-select>
        <mat-error
          class="text-danger"
          *ngIf="
            intermediaryBankForm.controls['country'].touched &&
            intermediaryBankForm.controls['country'].errors?.required
          "
        >
          País obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Cidade</mat-label>
        <input
          matInput
          formControlName="city"
          type="text"
          class=""
          name="city"
          required
        />
        <mat-error
          *ngIf="
            intermediaryBankForm.controls['city'].touched &&
            intermediaryBankForm.controls['city'].errors?.required
          "
        >
          Cidade obrigatória
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label>Banco</mat-label>
        <input
          matInput
          required
          formControlName="name"
          type="text"
          class="js-control-phone-company"
          name="name"
          required
        />
        <mat-error
          class="text-danger"
          *ngIf="
            intermediaryBankForm.controls['name'].touched &&
            intermediaryBankForm.controls['name'].errors?.required
          "
        >
          Banco obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'number')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Número da conta</mat-label>
        <input matInput formControlName="number" required />
        <mat-error
          *ngIf="
            form.get('number')?.touched &&
            form.get('number')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>SWIFT</mat-label>
        <input matInput formControlName="swift" required />
        <mat-error
          *ngIf="
            form.get('swift')?.touched &&
            form.get('swift')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'iban')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>IBAN</mat-label>
        <input matInput formControlName="iban" required />
        <mat-error
          *ngIf="
            form.get('iban')?.touched && form.get('iban')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'aba')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>ABA</mat-label>
        <input matInput formControlName="aba" required />
        <mat-error
          *ngIf="
            form.get('aba')?.touched && form.get('aba')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'blz')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>BLZ</mat-label>
        <input matInput formControlName="blz" />
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'cbu')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>CBU</mat-label>
        <input matInput formControlName="cbu" required />
        <mat-error
          *ngIf="
            form.get('cbu')?.touched && form.get('cbu')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'cuit')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>CUIT</mat-label>
        <input matInput formControlName="cuit" />
      </mat-form-field>
    </div>

    <div class="col-md-4" *ngIf="shouldShowField(intermediaryBankForm, 'bsb')">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>BSB</mat-label>
        <input matInput formControlName="bsb" />
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'institutionNumber')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Institution Number</mat-label>
        <input matInput formControlName="institutionNumber" required />
        <mat-error
          *ngIf="
            form.get('institutionNumber')?.touched &&
            form.get('institutionNumber')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'transit')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Transit</mat-label>
        <input matInput formControlName="transit" required />
        <mat-error
          *ngIf="
            form.get('transit')?.touched &&
            form.get('transit')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'address')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Endereço</mat-label>
        <input matInput formControlName="address" required />
        <mat-error
          *ngIf="
            form.get('address')?.touched &&
            form.get('address')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'cable')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Cable</mat-label>
        <input matInput formControlName="cable" required />
        <mat-error
          *ngIf="
            form.get('cable')?.touched &&
            form.get('cable')?.hasError('required')
          "
        >
          Campo obrigatório
        </mat-error>
      </mat-form-field>
    </div>

    <div
      class="col-md-4"
      *ngIf="shouldShowField(intermediaryBankForm, 'sortCode')"
    >
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Sort Code</mat-label>
        <input matInput formControlName="sortCode" />
      </mat-form-field>
    </div>
  </div>

  <div *ngIf="!isMobile" class="spacer"></div>

  <div class="buttons border-grey-light">
    <div class="cols d-flex">
      <button
        (click)="close()"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Cancelar
      </button>
    </div>
    <div class="cols d-flex">
      <button
        (click)="back()"
        type="button"
        *ngIf="!isMobile"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Voltar
      </button>
      <button
        (click)="submit()"
        [disabled]="invalidSubmit() || loading"
        type="submit"
        class="btn btn-block mt-0 ml-3"
        [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
        type="button"
      >
        {{ okText }}
        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
      </button>
    </div>
  </div>
</div>
